var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('md-app',[_c('md-app-content',[_c('router-view',{attrs:{"relogin":_vm.relogin}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }